module.exports = __webpack_public_path__ + "media/mail/fa-vk-dd1a20a8.png";